import React, { createContext, useState, } from 'react' 

interface CollectRefresh {
  collectContentUpdateTime?: Date, 
  setCollectContentUpdateTime?: (date:Date)=>void;
}

export const Context = createContext<CollectRefresh>({})

const RefreshCollectContent: React.FC = ({ children }) => { 
  const [collectContentUpdateTime, setCollectContentUpdateTime] = useState(new Date())
  return (
    <Context.Provider value={{
      collectContentUpdateTime,
      setCollectContentUpdateTime
    }}> 
      {children}
    </Context.Provider>
  )
}
 

export default RefreshCollectContent